export default "__VITE_ASSET__p8NMUVnZ__"